export default __webpack_public_path__ + "static/media/EM0290.34I-22005_-15046_0.19ff69bd.jpg";